import { useEffect, useState, type RefObject } from 'react';

/**
 * Below this the Capture label and the "/ total" half of the clock stop
 * fitting on one line, and the transport would wrap.
 */
export const COMPACT_THEATER_WIDTH_PX = 372;

/**
 * True while the theater is narrower than a full transport needs. The panel's
 * player column is resizable, so this is measured rather than derived from a
 * viewport breakpoint.
 */
export function useCompactTheater(ref: RefObject<HTMLElement | null>): boolean {
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element || typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setCompact(entry.contentRect.width < COMPACT_THEATER_WIDTH_PX);
      }
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);

  return compact;
}
